import { useContext, useEffect } from 'react';
import { useEnvironment } from '@/contexts/EnvironmentContext';
import { AuthContext } from '@/contexts/AuthContext';
import apiClient from '@/lib/apiClient';
import sseClient from '@/lib/sseClient';

export function useApiClient() {
  const { mode } = useEnvironment();
  const authContext = useContext(AuthContext);
  const isAuthenticated = authContext?.isAuthenticated ?? false;
  const sseEnabled = import.meta.env.VITE_ENABLE_SSE === '1';

  useEffect(() => {
    // Update API client environment when context changes
    apiClient.setEnvironment(mode);

    // Update SSE client environment
    sseClient.setEnvironment(mode);

    // Connect SSE for active environments
    if (sseEnabled && isAuthenticated) {
      console.log(`${mode} mode: SSE enabled`);
      sseClient.connect();
    } else if (!sseEnabled) {
      console.log('SSE disabled (VITE_ENABLE_SSE=0)');
      sseClient.disconnect();
    } else {
      console.log('SSE awaiting authenticated session');
      sseClient.disconnect();
    }

    // Cleanup on unmount or environment change
    return () => {
      sseClient.disconnect();
    };
  }, [mode, sseEnabled, isAuthenticated]);

  return apiClient;
}
